export const DOMESTIC_CANCELLATION_FEE = "R$ 450,00";
export const SOUTH_AMERICA_CANCELLATION_FEE = "US$ 185,00";
export const LONG_HAUL_CANCELLATION_FEE = "US$ 210,00";
export const DEFAULT_CANCELLATION_FEE = DOMESTIC_CANCELLATION_FEE;

const normalizeCountry = (country?: string): string =>
  (country ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const SOUTH_AMERICA_COUNTRIES = [
  "brasil",
  "brazil",
  "argentina",
  "bolivia",
  "chile",
  "colombia",
  "equador",
  "ecuador",
  "guiana",
  "guyana",
  "guiana francesa",
  "paraguai",
  "paraguay",
  "peru",
  "suriname",
  "uruguai",
  "uruguay",
  "venezuela",
].map(normalizeCountry);

export type CancellationAirport = {
  country?: string;
  timeZone?: string;
};

export type FlightRefundSegment = {
  chosenFlight?: {
    departure?: { airport?: CancellationAirport | null };
    arrival?: { airport?: CancellationAirport | null };
    legList?: Array<{
      departure?: { airport?: CancellationAirport | null };
      arrival?: { airport?: CancellationAirport | null };
    }>;
  };
};

const airportsOf = (segment: FlightRefundSegment): CancellationAirport[] => {
  const flight = segment.chosenFlight;
  const legAirports = (flight?.legList ?? []).reduce<Array<CancellationAirport | null | undefined>>((list, leg) => {
    return list.concat([leg.departure?.airport, leg.arrival?.airport]);
  }, []);
  const airports = [flight?.departure?.airport, flight?.arrival?.airport].concat(legAirports);

  return airports.filter((airport): airport is CancellationAirport => Boolean(airport));
};

const isDomestic = (airports: CancellationAirport[]): boolean =>
  airports.length > 0 &&
  airports.every((airport) => {
    const country = normalizeCountry(airport.country);
    return country === "brasil" || country === "brazil";
  });

export const getCancellationRefundFee = (segments: FlightRefundSegment[] = []): string => {
  const selected = segments.map(airportsOf).filter((airports) => airports.length > 0);

  if (selected.length > 0 && selected.every(isDomestic)) {
    return DOMESTIC_CANCELLATION_FEE;
  }

  const isEurope = selected.some((airports) =>
    airports.some((airport) => (airport.timeZone ?? "").startsWith("Europe/")),
  );
  if (isEurope) {
    return LONG_HAUL_CANCELLATION_FEE;
  }

  const isSouthAmericaOnly = selected.every((airports) =>
    airports.every((airport) => SOUTH_AMERICA_COUNTRIES.indexOf(normalizeCountry(airport.country)) !== -1),
  );

  return isSouthAmericaOnly ? SOUTH_AMERICA_CANCELLATION_FEE : LONG_HAUL_CANCELLATION_FEE;
};
